import { z } from 'zod';

const valuesSchema = z.object({
  slug: z.string(),
  value: z.union([z.boolean(), z.string()]),
});

export const employerConfigurationValuesSchema = z.array(valuesSchema);
